import React from 'react';
import { Img, Text, Button, Icon } from '../../Atoms';
import { Input, Modal } from '../../Molecules';
import notifTel from '../../assets/img/notifTel.png';

function ModalConfirmDelete(props) {
  return (
    <Modal
      show={props.show}
      showIconClose={false}
      centered={true}
      onHide={() => props.onHide()}
      contentClassName={
        'content-modal-confirm-password' + props.contentClassName
      }
    >
      {props.modalStep === 1 && (
        <div className='full-container'>
          <Icon
            icon='BigX'
            className='icon-close-modal-confim-password'
            size='20px'
            onClick={() => props.onCancel()}
          />
          <Text text={props.title} className='title-modal-confirm-password' />
          <p className='text-description-confirm-password' style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Important</p>
          <p className='text-description-confirm-password'>Si vous supprimez votre compte SPVIE Assurances, vous n&apos;aurez plus accès à l&apos;application mobile <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>ni</span> à l&apos;espace assuré web. Il vous faudra recommencer tout le processus de création de compte si vous souhaitez en créer un à nouveau.</p>
          <p className='text-description-confirm-password'>Toutefois, la suppression de votre compte <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>n&apos;entraine pas la résiliation de votre contrat.</span></p>
          <p className='text-description-confirm-password' style={{ fontWeight: 'bold' }}>Êtes-vous certain(e) de vouloir supprimer votre compte ?</p>
          <div className='container-center'>
            <Button
              text='Oui, je souhaite supprimer mon compte'
              className={`btn-submit-confirm-password btn-confirm-delete web-display-none`}
              onClick={props.onConfirmDeleteInModal}
            />
            <Button
              text='Oui, je souhaite supprimer mon compte'
              className={`btn-submit-confirm-password btn-confirm-delete mob-display-none`}
              onClick={props.onConfirmDeleteInModal}
            />
          </div>
          <div className='container-center'>
            <Button
              text='Non, je souhaite me rétracter'
              className={props.classNameBtnSubmit}
              onClick={props.onCancel}
            />
          </div>
        </div>
      )}
      {props.modalStep === 2 && (
        <div className='full-container'>
          <Icon
            icon='BigX'
            className='icon-close-modal-confim-password'
            size='20px'
            onClick={() => props.onCancel()}
          />
          <Text text={props.title} className='title-modal-confirm-password' />
          <p className='text-description-confirm-password'>Pour supprimer votre compte, merci de bien vouloir renseigner le code qui vient de vous être envoyé sur votre adresse email :</p>
          <div className='container-center'>
            <Input
              classNameContainer='container-input-confirm-change'
              className={props.classNameInput}
              placeholder='tapez le code ici'
              onChange={props.onChange}
              value={props.code}
              {...(props.verificationErrorMsg !== '' && { errorMsg: props.verificationErrorMsg })}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className='container-center'>
              <Button
                type='secondary'
                text='Annuler'
                className={`btn-cancel-cancel-password`}
                onClick={props.onCancel}
              />
            </div>
            <div className='container-center'>
              <Button
                text='Valider'
                className={`btn-cancel-confirm-password web-display-none`}
                onClick={props.onConfirmCodeDelete}
              />
              <Button
                text='Valider'
                className={`btn-cancel-confirm-password mob-display-none`}
                onClick={props.onConfirmCodeDelete}
              />
            </div>
          </div>
          <div className='resendCodeLink'><p className='resendCodeLinkText' onClick={props.sendCodeAgain}>Renvoyer le code</p></div>
        </div>
      )}
      {props.modalStep === 3 && (
        <div className='full-container'>
          <Icon
            icon='BigX'
            className='icon-close-modal-confim-password'
            size='20px'
            onClick={() => props.onCancel()}
          />
          <Text text={props.title} className='title-modal-confirm-password' />
          <p style={{
            display: "flex",
            justifyContent: "center"
          }} className='text-description-confirm-password'>Votre compte vient d&apos;être supprimé</p>
          <div className='container-center'>
            <Button
              text='Fermer'
              className={`${props.classNameBtnSubmit} mob-display-none`}
              onClick={props.onCloseDeleteModal}
            />
          </div>
        </div>
      )
      }
    </Modal >
  );
}
ModalConfirmDelete.defaultProps = {
  img: notifTel,
  contentClassName: '',
  modalStep: 1,
  title: '',
  firstText: '',
  secondText: '',
  onConfirmCode: null,
  onCancel: null,
  classNameBtncancel: 'btn-cancel-confirm-password btn-confirm-delete',
  classNameBtnSubmit: 'btn-submit-confirm-password btn-confirm-delete',
  classNameInput: 'input-confirm-change',
  onChange: null,
  code: ''
};
export default ModalConfirmDelete;
